import { render, staticRenderFns } from "./FileErrorPage.vue?vue&type=template&id=a367af8a&"
import script from "./FileErrorPage.vue?vue&type=script&lang=ts&"
export * from "./FileErrorPage.vue?vue&type=script&lang=ts&"
import style0 from "./FileErrorPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports